import { FilterCondition } from '@/features/analyze/types';

export const buildAnalyzeSearchUrl = (condition?: FilterCondition) => {
  if (!condition || Object.keys(condition).length === 0) {
    return '/analyze/search';
  }

  const serializedCondition = JSON.stringify(condition);
  return `/analyze/search#q=${encodeURIComponent(serializedCondition)}`;
};
